(function() {
  var SidebarKo,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SidebarKo = App.loadClass("core::viewmodels/filters/Sidebar");

  exports.Audit_Handler = (function(superClass) {
    extend(Audit_Handler, superClass);

    function Audit_Handler() {
      return Audit_Handler.__super__.constructor.apply(this, arguments);
    }

    Audit_Handler.prototype.init = function() {
      this.layoutUrl = 'backend/portal/audit/';
      this.subHandlers = {
        'Audit_Dialog': {
          'class': 'portal::handlers/audit/Audit_Dialog'
        }
      };
      this.defaultSub = 'Audit_Dialog';
      return this.loadLayout();
    };

    Audit_Handler.prototype.afterLoadLayout = function(selector, response) {
      var filters, handler, ref;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      filters = [
        {
          name: '',
          filters: [
            {
              name: 'years',
              display_name: 'Sales Year'
            }, {
              name: 'states',
              display_name: 'State'
            }, {
              name: 'changed_by',
              display_name: 'Changed By'
            }, {
              name: 'changed_for',
              display_name: 'Changed For'
            }, {
              name: 'order',
              display_name: 'Order #'
            }, {
              name: 'start_date',
              display_name: 'Start Date',
              control_type: 'datepicker'
            }, {
              name: 'end_date',
              display_name: 'End Date',
              control_type: 'datepicker'
            }
          ]
        }
      ];
      this.sidebar = new SidebarKo(filters);
      ko.applyBindings(this.sidebar, $(this.layoutSelector)[0]);
      handler = this.createSubHandler(this.defaultSub);
      if (handler) {
        handler.init();
      }
      App.sidebar.element.find('.dpl').datepicker();
      return $(this.layoutSelector).find('.report-applied-filters').undelegate().delegate('.applied-filter-header', 'click', function() {
        $(this).siblings('.applied-filter-value-container').slideToggle('fast');
        if ($(this).find('.caret-arrow').hasClass('caret-right')) {
          return $(this).find('.caret-arrow').removeClass('caret-right');
        } else {
          return $(this).find('.caret-arrow').addClass('caret-right');
        }
      });
    };

    return Audit_Handler;

  })(Handler);

}).call(this);
